import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReviews } from '../../actions/reviewActions';
import ReviewCard from './ReviewCard';
import { SpinLoader } from '../index';
import './Reviews.css';

const ReviewList = ({ productId }) => {
    const dispatch = useDispatch();
    const { loading, reviews } = useSelector(state => state.reviews);

    useEffect(() => {
        dispatch(fetchReviews(productId));
    }, [productId]); // eslint-disable-line

    if (loading) return (
        <div className='reviewListLoading'>
            <SpinLoader />
        </div>
    );

    return (
        <div className='reviewList'>
            {reviews.length === 0
                ? <p className='noReviews'>No reviews yet. Be the first to review!</p>
                : reviews.map((review, i) => <ReviewCard key={i} review={review} />)
            }
        </div>
    );
};

export default ReviewList;
